import { render, staticRenderFns } from "./WorkIconDown.vue?vue&type=template&id=0131c9bf"
import script from "./WorkIconDown.vue?vue&type=script&lang=js"
export * from "./WorkIconDown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports